import { memo } from "react";
import { useTranslation } from "react-i18next";

export enum PriceTextVariants {
  monthlySubsription,
  monthlySubsriptionStartWithBigLetter,
  yearlySubscription,
  targetPrice,
  offer,
  netPrice,
  listPrice,
}

//without any proprs returns "per piece" / "per ${priceUnit} pieces"
interface Props {
  priceUnit: number;
  variant?: PriceTextVariants | null;
}

const SimplePriceText = (props: Props) => {
  const { t } = useTranslation();
  const { priceUnit, variant } = props;

  if (variant === PriceTextVariants.yearlySubscription) {
    return <span>{t("common.product.perYear")}</span>;
  } else if (variant === PriceTextVariants.monthlySubsription) {
    return <span>{t("common.product.perMonth")}</span>;
  } else if (variant === PriceTextVariants.monthlySubsriptionStartWithBigLetter) {
    return <span>{t("common.product.perMonthBigLetter")}</span>;
  } else if (variant === PriceTextVariants.targetPrice) {
    return (
      <span>
        {t("addProduct.salesman.targetPricePerPiece", {
          count: priceUnit,
        })}
      </span>
    );
  } else if (variant === PriceTextVariants.offer) {
    return (
      <span>
        {t("common.product.offerPricePerPiece", {
          count: priceUnit,
        })}
      </span>
    );
  } else if (variant === PriceTextVariants.netPrice) {
    return (
      <span>
        {t("common.product.netPricePerPiece", {
          count: priceUnit,
        })}
      </span>
    );
  } else if (variant === PriceTextVariants.listPrice) {
    return (
      <span>
        {t("addProduct.salesman.listPricePerPiece", {
          count: priceUnit,
        })}
      </span>
    );
  } else {
    return <span>{t("common.product.perPiece", { count: priceUnit })}</span>;
  }
};

export default memo(SimplePriceText);
